import { useState, useContext, useEffect, useRef } from "react";
import { ProductsContext } from "../../contexts/ProductsContext";
import "./CompraPage.styles.scss";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import StepperCheckout from "../../components/CheckoutStepper/StepperCheckout";
import EntrarForm from "../../components/LoginForms/EntrarForm/EntrarForm";
import ModalComponent from "../../components/Modal/ModalComponent";
import ModalVinculoComponent from "../../components/ModalVinculo/ModalVinculoComponent";
import ModalAccountComponent from "../../components/ModalAccount/ModalAccountComponent";
import RegistrarForm from "../../components/LoginForms/RegistrarForm/RegistrarForm";
import { AccountContext } from "../../contexts/AccountContext";
import { CartContext } from "../../contexts/CartContext";
import VinculateStudent from "../../components/VinculateStudent/VinculateStudent";
import ItemDisplay from "../../components/ItemDisplay/ItemDisplay";
import { GlobalContext } from "../../contexts/GlobalContext";
import Payment from "../../components/Payment/Payment";
import PaymentCart from "../../components/PaymentCart/PaymentCart";
import ModalidadeSelectionStep from "../../components/ModalidadeSelectionStep/ModalidadeSelectionStep";
import { useMediaQuery } from "react-responsive";

const TICKET_CATEGORY_ID = process.env.REACT_APP_TICKET_CATEGORY_ID;
const REVISION_CATEGORY_ID = process.env.REACT_APP_REVISION_CATEGORY_ID;

const CompraPage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [typeForm, setTypeForm] = useState(1);
  const hasAddedToCartRef = useRef(false);
  const currentStepRef = useRef(currentStep);
  useEffect(() => {
    currentStepRef.current = currentStep;
  });
  
  const { selectedSubproduct, selectedProduct } = useContext(ProductsContext);
  const { carrinho, bagsData } = useContext(GlobalContext);
  const { loggedUserData } = useContext(AccountContext);
  const { alreadyStudent } = useContext(CartContext);
  const navigate = useNavigate();

  const isNotMobileDevice = useMediaQuery({
    query: "(min-device-width: 769px)",
  });

  // verificar se o produto selecionado é ingresso/revisão
  const isTicketOrRevision = selectedProduct?.categoryId === TICKET_CATEGORY_ID ||
                              selectedProduct?.categoryId === REVISION_CATEGORY_ID;

  const hasModalidade = !isTicketOrRevision && !!selectedSubproduct?.possui_modalidade;

  const steps = isTicketOrRevision
    ? ["Autenticação", "Pagamento"]
    : hasModalidade
      ? ["Autenticação", "Selecionar Destinatário", "Modalidades", "Pagamento"]
      : ["Autenticação", "Selecionar Destinatário", "Pagamento"];

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  useEffect(() => {
    if (
      isTicketOrRevision && 
      loggedUserData && 
      selectedSubproduct && 
      currentStep === 2 &&
      !hasAddedToCartRef.current
    ) {
      hasAddedToCartRef.current = true;
      alreadyStudent(selectedSubproduct, () => {

      });
    }
  }, [
    isTicketOrRevision,
    loggedUserData,
    selectedSubproduct,
    currentStep,
    alreadyStudent,
  ]);

  useEffect(() => {
    if (!loggedUserData) {
      setCurrentStep(1);
    } else if (currentStepRef.current < 2) {
      setCurrentStep(2);
    }

    if (!selectedSubproduct) {
      if (!carrinho || (!carrinho.length && !bagsData.length)) {
        navigate("/");
      }
      if (currentStepRef.current < 3) {
        if (isTicketOrRevision) {
          setCurrentStep(2);
        } else {
          setCurrentStep(3);
        }
      }
    }
  }, [
    loggedUserData,
    selectedSubproduct,
    carrinho,
    bagsData,
    navigate,
    isTicketOrRevision,
  ]);

  const displayStep = (step) => {
    // se é ingresso/revisão entra aqui
    if (isTicketOrRevision) {
      switch (step) {
        case 1:
          return (
            <div className="mt-5 flex flex-col justify-center">
              {typeForm ? (
                <EntrarForm notModal={true} />
              ) : (
                <RegistrarForm notModal={true} />
              )}
              {typeForm ? (
                <p className="change-form text-center">
                  Ainda não é cliente?
                  <br />
                  Crie sua conta clicando{" "}
                  <span
                    className="text-link"
                    onClick={() => setTypeForm(!typeForm)}
                  >
                    aqui
                  </span>
                  !
                </p>
              ) : (
                <p className="change-form text-center">
                  Já é cliente?
                  <br />
                  Faça o login clicando{" "}
                  <span
                    className="text-link"
                    onClick={() => setTypeForm(!typeForm)}
                  >
                    aqui
                  </span>
                  !
                </p>
              )}
            </div>
          );
        default:

          return <Payment />;
      }
    }

    switch (step) {
      case 1:
        return (
          <div className="mt-5 flex flex-col justify-center">
            {typeForm ? (
              <EntrarForm notModal={true} />
            ) : (
              <RegistrarForm notModal={true} />
            )}
            {typeForm ? (
              <p className="change-form text-center">
                Ainda não é cliente?
                <br />
                Crie sua conta clicando{" "}
                <span
                  className="text-link"
                  onClick={() => setTypeForm(!typeForm)}
                >
                  aqui
                </span>
                !
              </p>
            ) : (
              <p className="change-form text-center">
                Já é cliente?
                <br />
                Faça o login clicando{" "}
                <span
                  className="text-link"
                  onClick={() => setTypeForm(!typeForm)}
                >
                  aqui
                </span>
                !
              </p>
            )}
          </div>
        );
      case 2:
        return <VinculateStudent nextStep={nextStep} />;
      case 3:
        if (hasModalidade) {
          return <ModalidadeSelectionStep nextStep={nextStep} />;
        }
        return <Payment />;
      default:
        return <Payment />;
    }
  };

  if (currentStep >= 2 || !!selectedProduct || !!selectedSubproduct) {
    return (
      <div className="compra-main-container">
        <Helmet>
          <title>Checkout | Propósito Store</title>
          <meta name="description" content="Checkout Propósito Store" />
        </Helmet>
        <ModalComponent />
        <ModalAccountComponent />
        {loggedUserData && <ModalVinculoComponent />}
        <div className="step-content-container">
          <div className="checkout-stepper">
            <StepperCheckout steps={steps} currentStep={currentStep} />
            {displayStep(currentStep)}
          </div>
        </div>
        {/* Mostrar ItemDisplay ou PaymentCart */}
        {(isTicketOrRevision && currentStep === 2) || currentStep === 3 || currentStep === 4 ? (
          isNotMobileDevice ? (
            <PaymentCart />
          ) : (
            <></>
          )
        ) : (
          selectedSubproduct ? <ItemDisplay /> : <></>
        )}
      </div>
    );
  }

  return <></>;
};

export default CompraPage; 